import React, { useEffect } from 'react';

export const Download = () => {
  return (
    <>
      <p>
        Clicking the Download button on any of the pages will display the
        Download File page. From this page you are able to download all the
        transactions for the page regardless of the transactions displayed on
        the page. Only 65,000 rows of data may be downloaded at one time. If the
        number of rows to download exceeds this amount, multiple files will be
        created for download. Click on the Download File button to download the
        file.
      </p>
      <br />
    </>
  );
};
